import axios from "axios"

const prefix: string = 'Permissions/';

export const getClaims = () => {
    return axios.get(`${prefix}GetClaims`);
}
